module.exports = __webpack_public_path__ + "static/media/image3.766d3b6c.png";